<template>
    <k-panel>
        <k-panel-header slot="header" border="border-none">Repayment schedule</k-panel-header>
        <k-table v-if="tranche.paymentScheduleSummary"
                 :data-set="{items: tranche.paymentScheduleSummary.payments}" :pagination-visible="false"
                 row-key="paymentDate">
            <a-table-column title="Payment date" key="paymentDate" data-index="paymentDate" :ellipsis="true"/>
            <a-table-column title="Interest" key="interest" data-index="interest" :ellipsis="true"
                            align="right">
                <template slot-scope="text">
                    {{text | currencyFormat(tranche.currencySymbol)}}
                </template>
            </a-table-column>
            <a-table-column title="Principal" key="principal" data-index="principal"
                            :ellipsis="true"
                            align="right">
                <template slot-scope="text">
                    {{text | currencyFormat(tranche.currencySymbol)}}
                </template>
            </a-table-column>
            <a-table-column title="Total" key="total" data-index="total" :ellipsis="true" align="right">
                   <template slot-scope="text">
                                {{text | currencyFormat(tranche.currencySymbol)}}
                   </template>
            </a-table-column>
        </k-table>
    </k-panel>
</template>

<script>
    export default {
        props: {
            tranche: {
                type: Object,
                required: true
            }
        }
    };
</script>


